import React, { useRef, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

const TableauDashboard = ({ url, eventId, orgId }) => {
  const vizRef = useRef(null);
  const [viz, setViz] = useState();

  const initViz = () => {
    setViz(
      <tableau-viz ref={vizRef} id="tableauViz" src={url} toolbar="hidden" height="520" width="100%">
        <viz-filter field="EVENT ID" value={eventId} />
        <viz-filter field="ORG ID" value={orgId} />
      </tableau-viz>
    );
  };

  useEffect(() => {
    initViz();
  }, []);

  if (url) {
    return (
      <>
        <Helmet>
          <script type="module" src="https://public.tableau.com/javascripts/api/tableau.embedding.3.1.0.min.js" async />
        </Helmet>
        <div
          className="mx-0"
          style={{ display: 'block', position: 'relative', overflow: 'visible', height: '450px', width: '100%' }}
        >
          {viz}
        </div>
      </>
    );
  }
  return null;
};

TableauDashboard.propTypes = {
  url: PropTypes.object.isRequired,
  eventId: PropTypes.object.isRequired,
  orgId: PropTypes.object.isRequired,
};

export default TableauDashboard;
